module.exports = __webpack_public_path__ + "static/media/fake-news-splash.593d15cf.png";